import get from "lodash-es/get";
import has from "lodash-es/has";
export var LanguageCodeRegex = {
    /**
     * lanuageValidationRegex
     * Regex to test language id against to determine whether
     * a string is a valid language id
     */
    Loose: /^([a-zA-Z]{2})([-|_][a-zA-Z]{2,10})?$/,
    /**
     * lanuageValidationRegex
     * Regex to test language id against to determine whether
     * a string is a valid language id
     */
    Strict: /^([a-zA-Z]{2})([-|_][a-zA-Z]{2})?$/,
};
/**
 * List with right to left (RTL) language id's
 * Source: https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
 */
var rtlLanguageIds = [
    "ar",
    "arc",
    "ckb",
    "dv",
    "fa",
    "ha",
    "he",
    "khw",
    "ks",
    "ps",
    "ur",
    "uz-af",
    "yi",
];
/**
 * setGlobalValidationRegex
 *
 * @param regex
 */
export var setGlobalValidationRegex = function (regex) {
    globalValidationRegex = regex;
};
/**
 * getGlobalValidationRegex
 */
export var getGlobalValidationRegex = function () { return globalValidationRegex; };
/**
 * isValid
 * Is provided language a valid language id?
 *
 * @param language
 */
export var isValidLanguageId = function (language) { return language && language.indexOf("null") === -1 && globalValidationRegex.test(language); };
/**
 * resolveTranslationValue
 *
 * @param languages
 * @param name
 * @param languageId
 * @param defaultValue
 */
export var resolveTranslationValue = function (languages, name, languageId, defaultValue, fallbackToFirstAvailable) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (fallbackToFirstAvailable === void 0) { fallbackToFirstAvailable = false; }
    var translatableLanguageId = resolveTranslatableLanguageId(languages, name, languageId, defaultValue, fallbackToFirstAvailable);
    return translatableLanguageId !== undefined ? get(languages, translatableLanguageId + "." + name, defaultValue) : defaultValue;
};
/**
 * resolveTranslatableLanguageId
 *
 * @param languages
 * @param name
 * @param languageId
 * @param defaultValue
 */
export var resolveTranslatableLanguageId = function (languages, name, languageId, defaultValue, fallbackToFirstAvailable) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (fallbackToFirstAvailable === void 0) { fallbackToFirstAvailable = false; }
    var languageIds = Array.isArray(languageId) ? languageId : [languageId];
    var keys = resolveLanguageKeys(languageIds);
    var foundId = keys.find(function (id) { return has(languages, id + "." + name); });
    if (foundId === undefined) {
        keys.find(function (id) {
            foundId = Object.keys(languages).find(function (textLanguageId) { return !!id && textLanguageId.match("^" + id) !== null; });
            return !!foundId;
        });
    }
    if (foundId === undefined && fallbackToFirstAvailable) {
        foundId = Object.keys(languages)[0];
    }
    return foundId;
};
/**
 * isRtlLanguageId
 * Check whether provides language id is a RTL language
 *
 * @param languageId
 */
export var isRtlLanguageId = function (languageId) {
    var segments = extractCodeSegments(languageId);
    var languageCode = segments[0] || null;
    return rtlLanguageIds.includes(languageId) || rtlLanguageIds.includes(languageCode);
};
/**
 * Private
 */
/**
 * resolveLanguageKeys
 * Helper to create an array with language id segment keys, based
 * on the provided languageId's.
 * Segment can be "en" or "US" in "en-US", etc.
 */
export var resolveLanguageKeys = function (languageIds) {
    var languageKeys = [];
    // helper function to add segment to languageKeys when it's
    // not already added to the segments
    var addSegment = function (segment, segments) {
        if (segments.indexOf(segment) === -1) {
            segments.push(segment);
        }
    };
    languageIds.forEach(function (languageId) {
        var segments = extractCodeSegments(languageId);
        // check before adding if not in result array already...
        // @note - make sure NULL and undefined values are ignored.
        if (segments.length > 0 && !!segments[0]) {
            if (!!segments[1]) {
                addSegment(languageId, languageKeys); // add full language id
            }
            addSegment(segments[0], languageKeys); // add en in en-GB
        }
    });
    return languageKeys;
};
/**
 * extractRegionCode
 * Helper to extract the region code from a language id
 *
 * @param languageId
 */
export var extractRegionCode = function (languageId) { return extractCodeSegments(languageId)[1] || null; };
/**
 * extractLanguageCode
 * Helper to extract the region code from a language id
 *
 * @param languageId
 */
export var extractLanguageCode = function (languageId) { return extractCodeSegments(languageId)[0] || null; };
/**
 * extractCodeSegments
 * Helper method to extract code segments (language and region)
 * from a languageId (e.g. en-GB)
 */
export var extractCodeSegments = function (languageId) { return (typeof languageId === "string" ? languageId.split("-") : []); };
/**
 * Private
 */
export var globalValidationRegex = LanguageCodeRegex.Strict;
//# sourceMappingURL=I18n.js.map